import React, { useEffect, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { CommunityRepository } from 'app/shared/data-access/communities/community-repository'
import { useRequireUserContext } from 'app/shared/state/require-user-context'
import { useToastContext } from 'app/shared/state/toast-context'
import { CompanyRepository } from 'app/shared/data-access/communities/companies/company-repository'

type Props = {
    hostname: string
}

const Home = (props: Props) => {
    const { toastOnError } = useToastContext()
    const { push } = useHistory()
    const { currentUser } = useRequireUserContext()

    const redirectUser = useCallback(async () => {
        var result = toastOnError(await CommunityRepository.getByHostname(props.hostname))

        if (currentUser.isGlobalAdmin) {
            push('/communities')
            return
        }

        if (result.error || !result.data || !result.data.community) {
            push('/communities')
            return
        }

        const userId = result.data.defaultCompanyUserId
        const communityId = result.data?.community.id
        const companyId = result.data.defaultCompanyId
        const isCommunityAdmin = result.data?.communitiesCount > 0

        if (!companyId || !userId || result.data?.communitiesCount === 1) {
            push(`/communities/${communityId}`)
            return
        }

        if (isCommunityAdmin) {
            push('/communities')
            return
        }

        const isCompanyAdmin = currentUser.companyUserRoles &&
            currentUser.companyUserRoles.findIndex((x) => x.companyId === companyId &&
                x.role === 'CompanyAdministrator') > -1

        const companies = toastOnError(await CompanyRepository.getCompanies(communityId))

        if (
            isCompanyAdmin === true && companies.data && companies.data.length === 1
        ) {
            push(`/communities/${communityId}/companies/${companyId}`)
            return
        }

        if (
            isCompanyAdmin === true && companies.data && companies.data.length > 1
        ) {
            push(`/communities/${communityId}`)
            return
        }

        push(`/communities/${communityId}/companies/${companyId}/companyusers/${userId}`)
    }, [currentUser.companyUserRoles, currentUser.isGlobalAdmin, props.hostname, push])

    useEffect(() => {
        redirectUser()
    }, [redirectUser])

    return <></>
}

export default Home
